namespace $ {

	/**
	 * Theme css variables
	 * @see https://mol.hyoo.ru/#!section=demos/demo=mol_textarea_demo
	 */	
	export const $mol_theme = $mol_style_prop(
		'mol_theme',
		[
			'back',
			'hover',
			'card',
			'current',
			'special',
			'text',
			'control',
			'shade',
			'line',
			'focus',
			'field',
			'image',
			'spirit',
			'hue',
			'hue_spread',
		] as const
	)

}
